/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordListSectionParameters
 */
export interface RecordListSectionParameters {
    /**
     * 
     * @type {Array<string>}
     * @memberof RecordListSectionParameters
     */
    guids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RecordListSectionParameters
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof RecordListSectionParameters
     */
    description?: string;
}

/**
 * Check if a given object implements the RecordListSectionParameters interface.
 */
export function instanceOfRecordListSectionParameters(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "guids" in value;

    return isInstance;
}

export function RecordListSectionParametersFromJSON(json: any): RecordListSectionParameters {
    return RecordListSectionParametersFromJSONTyped(json, false);
}

export function RecordListSectionParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordListSectionParameters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'guids': json['guids'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function RecordListSectionParametersToJSON(value?: RecordListSectionParameters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'guids': value.guids,
        'title': value.title,
        'description': value.description,
    };
}

